/* ============================================================
   SOLVEY · Firmhouse / Solvey subscription-card i18n
   ------------------------------------------------------------
   Vertaalt 3 groepen hardcoded teksten in de Firmhouse-cards:

   1. Selling-plan group name ("Subscribe & Save") — komt uit
      Firmhouse admin, wordt na elke widget-rerender opnieuw in
      NL ingezet, dus we overschrijven .option-name in
      .subscription-card naar de current-language variant.

   2. Solvey sub-bullets (5 stuks) — worden door onze eigen
      bullet-injection scripts (assets/solvey-*-bullets.js) als
      hardcoded EN strings in <ul class="solvey-sub-bullets"> li
      span gezet. Weglot ziet deze pas ná injectie en mist soms
      de re-translate-pass. We overschrijven op basis van de
      EN bron-tekst als sleutel.

   Strategie:
   - Brede selectors zonder verplichte fh-widget parent
   - Body-level MutationObserver pakt alle (re-)renders inclusief
     lazy-loaded en JS-injected bullets
   - Re-run op Weglot 'languageChanged', pageshow, focus,
     visibilitychange + 10s poll-fallback voor late Weglot init
   - Vervang alleen als huidige tekst een BEKEND label is —
     zo raken we geen onvoorziene elementen
   ============================================================ */
(function () {
  'use strict';

  /* ---- Selling-plan group name --------------------------- */
  var PLAN_LABELS = {
    nl: 'Abonneer & Bespaar',
    en: 'Subscribe & Save',
    de: 'Abonnieren & Sparen',
    da: 'Abonnér & Spar',
    fr: 'Abonner & Économiser'
  };
  var ALL_PLAN_LABELS = Object.keys(PLAN_LABELS).map(function (k) { return PLAN_LABELS[k]; });

  /* ---- Solvey sub-bullets (key = EN bron-tekst) ---------- */
  var BULLET_LABELS = {
    'Trusted by 30,000+ women': {
      nl: 'Vertrouwd door 30.000+ vrouwen',
      en: 'Trusted by 30,000+ women',
      de: 'Vertraut von 30.000+ Frauen',
      da: 'Betroet af 30.000+ kvinder',
      fr: 'Approuvé par 30 000+ femmes'
    },
    '100% Natural & Clinically Tested': {
      nl: '100% Natuurlijk & Klinisch Getest',
      en: '100% Natural & Clinically Tested',
      de: '100% Natürlich & Klinisch Getestet',
      da: '100% Naturligt & Klinisk Testet',
      fr: '100% Naturel & Cliniquement Testé'
    },
    'Expertly developed with gynecological input': {
      nl: 'Deskundig ontwikkeld met gynaecologische input',
      en: 'Expertly developed with gynecological input',
      de: 'Fachkundig entwickelt mit gynäkologischem Input',
      da: 'Ekspertudviklet med gynækologisk input',
      fr: 'Développé par des experts avec apport gynécologique'
    },
    '60-day money-back guarantee': {
      nl: '60 dagen niet-goed-geld-terug garantie',
      en: '60-day money-back guarantee',
      de: '60 Tage Geld-zurück-Garantie',
      da: '60 dages pengene-tilbage-garanti',
      fr: 'Garantie satisfait ou remboursé 60 jours'
    },
    'Flexible subscription, cancel anytime': {
      nl: 'Flexibel abonnement, altijd opzegbaar',
      en: 'Flexible subscription, cancel anytime',
      de: 'Flexibles Abonnement, jederzeit kündbar',
      da: 'Fleksibelt abonnement, opsig når som helst',
      fr: 'Abonnement flexible, annulable à tout moment'
    },
    /* Shave Bar — 2-pack card bullets (geïnjecteerd door solvey-shavebar-pack.js
       in <ul class="solvey-pack-bullets">). Zelfde patroon: EN bron-text als
       sleutel, vervang via current-language. */
    'Best value: save the most': {
      nl: 'Beste keuze: bespaar het meest',
      en: 'Best value: save the most',
      de: 'Bester Wert: am meisten sparen',
      da: 'Bedste værdi: spar mest',
      fr: 'Meilleur rapport qualité-prix : économisez le plus'
    },
    'Long-lasting care for smooth, comfortable skin': {
      nl: 'Langdurige verzorging voor zachte, comfortabele huid',
      en: 'Long-lasting care for smooth, comfortable skin',
      de: 'Lang anhaltende Pflege für glatte, angenehme Haut',
      da: 'Langvarig pleje for glat, behagelig hud',
      fr: 'Soin longue durée pour une peau douce et confortable'
    },
    'Fewer reorders, more convenience': {
      nl: 'Minder nabestellen, meer gemak',
      en: 'Fewer reorders, more convenience',
      de: 'Weniger Nachbestellungen, mehr Komfort',
      da: 'Færre genbestillinger, mere bekvemmelighed',
      fr: 'Moins de commandes, plus de praticité'
    },
    'Always have a backup on hand': {
      nl: 'Altijd een reserve in huis',
      en: 'Always have a backup on hand',
      de: 'Immer einen Vorrat zur Hand',
      da: 'Hav altid en reserve ved hånden',
      fr: 'Toujours un de réserve sous la main'
    },
    'Pause or cancel anytime': {
      nl: 'Pauzeer of stop wanneer je wilt',
      en: 'Pause or cancel anytime',
      de: 'Jederzeit pausieren oder kündigen',
      da: 'Sæt på pause eller opsig når som helst',
      fr: 'Mettez en pause ou annulez à tout moment'
    }
  };

  // Bouw reverse-lookup: elke vertaling → EN sleutel, zodat we ook
  // kunnen detecteren of een bullet al in NL/DE/DA/FR staat en hem
  // toch nog veilig kunnen vertalen.
  var BULLET_REVERSE = {};
  Object.keys(BULLET_LABELS).forEach(function (key) {
    var langs = BULLET_LABELS[key];
    Object.keys(langs).forEach(function (lang) {
      BULLET_REVERSE[langs[lang]] = key;
    });
  });

  /* ---- Tagline onder de cards (was CSS ::after, niet vertaalbaar) ---- */
  var TAGLINE = {
    nl: 'Gebruik 2-3 maanden voor het beste resultaat',
    en: 'Use for 2-3 months for optimal results',
    de: '2-3 Monate verwenden für optimale Ergebnisse',
    da: 'Brug i 2-3 måneder for optimale resultater',
    fr: 'Utiliser pendant 2-3 mois pour des résultats optimaux'
  };

  /* Carvacrol-PDP heeft een afwijkende tagline (1 maand i.p.v. 2-3) */
  var TAGLINE_OVERRIDES = {
    'product-handle--carvacrol-complex-oregano-oil': {
      nl: 'Gebruik 1 maand voor het beste resultaat',
      en: 'Use 1 month for optimal results',
      de: '1 Monat verwenden für optimale Ergebnisse',
      da: 'Brug i 1 måned for optimale resultater',
      fr: 'Utiliser pendant 1 mois pour des résultats optimaux'
    }
  };

  function currentLang() {
    var lang;
    if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
      lang = window.Weglot.getCurrentLang();
      if (lang) return String(lang).toLowerCase().split('-')[0];
    }
    if (window.Shopify && window.Shopify.locale) {
      return String(window.Shopify.locale).toLowerCase().split('-')[0];
    }
    if (document.documentElement.lang) {
      return String(document.documentElement.lang).toLowerCase().split('-')[0];
    }
    return 'nl';
  }

  function translatePlanLabels(lang) {
    var label = PLAN_LABELS[lang];
    if (!label) return;
    var nodes = document.querySelectorAll('li.subscription-card .option-name, .subscription-card .option-name');
    nodes.forEach(function (el) {
      var txt = el.textContent.trim();
      if (txt === label) return;
      if (ALL_PLAN_LABELS.indexOf(txt) !== -1 || txt === '') {
        el.textContent = label;
      }
    });
  }

  function translateBullets(lang) {
    // .solvey-sub-bullets = globale 5 bullets per PDP (via solvey-*-bullets.js)
    // .solvey-pack-bullets = shave-bar 2-pack card bullets (via solvey-shavebar-pack.js)
    var nodes = document.querySelectorAll('.solvey-sub-bullets li span, .solvey-pack-bullets li span');
    nodes.forEach(function (span) {
      var txt = span.textContent.trim();
      var key = BULLET_REVERSE[txt];
      if (!key) return;
      var target = BULLET_LABELS[key][lang];
      if (!target || txt === target) return;
      span.textContent = target;
    });
  }

  // NVWA-compliance (2026-06-22): de tagline onder de subscription/one-time
  // cards ("Use for 2-3 months for optimal results" en varianten) moet volledig
  // weg van ÁLLE PDP's. We injecteren niets meer en verwijderen actief een
  // eventueel al aanwezige span (ook na re-render / Weglot language change).
  // TAGLINE / TAGLINE_OVERRIDES blijven staan zodat dit makkelijk terug te
  // draaien is als het ooit weer mag.
  function translateTagline(lang) {
    document.querySelectorAll('.solvey-firmhouse-tagline').forEach(function (span) {
      span.remove();
    });
  }

  /* ---- Frequentie-sublabel onder de plannaam ------------- */
  // Owner-wens 2026-07-01: onder "Abonneer & Bespaar" moet "elke 6 weken"
  // (EN "every 6 weeks", enz.) staan. We wrappen .option-name samen met een
  // lege <span class="solvey-fq-sub"> in een kolom-div; de zichtbare tekst
  // komt uit CSS ::after per html[lang] (zie custom.css) zodat Weglot 'm niet
  // herschrijft. Idempotent + herbouwt zichzelf na elke Firmhouse-rerender via
  // de body-MutationObserver. Alleen op de subscription-card (niet one-time).
  function ensureFreqLabel() {
    var rows = document.querySelectorAll('li.subscription-card .card-header .card-row');
    rows.forEach(function (row) {
      var on = row.querySelector('.option-name');
      if (!on) return;
      var col = on.parentElement;
      if (!col || !col.classList || !col.classList.contains('solvey-plan-col')) {
        col = document.createElement('div');
        col.className = 'solvey-plan-col';
        on.parentElement.insertBefore(col, on);
        col.appendChild(on);
      }
      if (!col.querySelector('.solvey-fq-sub')) {
        var sub = document.createElement('span');
        sub.className = 'solvey-fq-sub wg-notranslate';
        sub.setAttribute('data-wg-notranslate', '');
        col.appendChild(sub);
      }
    });
  }

  function translateAll() {
    var lang = currentLang();
    translatePlanLabels(lang);
    translateBullets(lang);
    translateTagline(lang);
    ensureFreqLabel();
  }

  var debounceTimer = null;
  function scheduleTranslate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(translateAll, 50);
  }

  var bodyObserver = null;
  function startBodyObserver() {
    if (bodyObserver || !document.body) return;
    bodyObserver = new MutationObserver(scheduleTranslate);
    bodyObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function hookWeglot() {
    if (window.Weglot && typeof window.Weglot.on === 'function') {
      try { window.Weglot.on('languageChanged', scheduleTranslate); } catch (e) {}
      try { window.Weglot.on('initialized', scheduleTranslate); } catch (e) {}
      return true;
    }
    return false;
  }

  function boot() {
    startBodyObserver();
    translateAll();
    hookWeglot();

    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      hookWeglot();
      scheduleTranslate();
      if (tries > 50) clearInterval(poll);
    }, 200);
  }

  window.addEventListener('pageshow', scheduleTranslate);
  window.addEventListener('focus', scheduleTranslate);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleTranslate();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
